// extracted by mini-css-extract-plugin
module.exports = {"container":"_2aa-Hh1ZdU2FnHqrIuK_CU"};